import script from "./CatalogTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogTab.vue?vue&type=script&setup=true&lang=js"

import "./CatalogTab.vue?vue&type=style&index=0&id=25865701&scoped=true&lang=css"
import "./CatalogTab.vue?vue&type=style&index=1&id=25865701&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25865701"]])

export default __exports__